import React, { useCallback, useState } from 'react';
import styled from '@emotion/styled';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { SelectOption } from '../../atoms';
import { TRY_THEN_BUY } from '../../../constants/define/translation';
import { TTB_FILTER_STATUS } from '../../../constants/ttb';
import { FilterTTBType } from '../../../types/tryThenBuy';
import { appStyles } from '../../../styles';

interface TTBFilterProps {
  getFilteredData: (data: any) => void;
  options: FilterTTBType;
  isRoleTTBAgent?: boolean;
}

export const TTBFilter = (props: TTBFilterProps) => {
  const { t } = useTranslation(TRY_THEN_BUY);
  const { getFilteredData, options, isRoleTTBAgent } = props;
  const [isCheckedAbnormalOrder, setIsCheckedAbnormalOrder] = useState(false);

  const onHandleSelectTTBStatus = useCallback(
    values => {
      getFilteredData({
        status: values,
        abnormalOrder: isCheckedAbnormalOrder,
      });
    },
    [getFilteredData, isCheckedAbnormalOrder],
  );

  return (
    <StyledRowFilter>
      <Col span={16} className="full-width">
        <Row style={{ width: '100%' }}>
          <Col span={12}>
            {!isRoleTTBAgent && (
              <>
                <div className="text-filter">
                  <span className="text">{t('filter.status')}: </span>
                </div>

                <SelectOption
                  multiple
                  values={TTB_FILTER_STATUS}
                  showSearch
                  defaultValue={options?.status}
                  placeholder={t('filter.status')}
                  onChange={onHandleSelectTTBStatus}
                  textDisplay="text"
                />
              </>
            )}
          </Col>
          <Col span={10} offset={2}>
            <Row>
              <Col span={24}>
                {!isRoleTTBAgent && (
                  <Row style={{ width: '100%' }}>
                    <Col span={20}>
                      <div className="text-filter">
                        <span className="text">{t('filter.abnormalOrder')}: </span>
                      </div>
                    </Col>
                    <Col span={4}>
                      <div className="div-filter-abnormalOrder" style={{ justifyContent: 'flex-end' }}>
                        <Switch
                          onChange={value => {
                            getFilteredData({
                              abnormalOrder: value,
                            });
                            setIsCheckedAbnormalOrder(value);
                          }}
                          checked={isCheckedAbnormalOrder}
                        />
                      </div>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col offset={2} span={6}>
        <StyledSearchInput
          onChange={e => {
            getFilteredData({
              strSearch: e.target.value,
            });
          }}
          value={options?.strSearch}
          placeholder={t(isRoleTTBAgent ? 'filter.searchAgentPlaceholder' : 'filter.searchPlaceholder')}
          suffix={
            !options?.strSearch ? (
              <SearchOutlined />
            ) : (
              <CloseOutlined
                onClick={() => {
                  getFilteredData({
                    strSearch: '',
                  });
                }}
              />
            )
          }
        />
      </Col>
    </StyledRowFilter>
  );
};

const StyledRowFilter = styled(Row)`
  padding: 0.5rem 0 0.75rem;
  & .full-width {
    .ant-select {
      width: 280px;
      min-width: 280px;
      max-width: 400px;
    }
  }

  & .ant-col {
    display: flex;
    & .text-filter {
      display: table;
      height: 36px;
      margin-right: 0.5rem;
      & span {
        font-weight: bold;
        font-size: 14px;
        display: table-cell;
        vertical-align: middle;
      }
    }
    & .ant-select-selector {
      line-height: 1.89;
    }
  }

  & .div-filter-passScheduledArrivalDate,
  & .div-filter-abnormalOrder {
    padding: 0.22rem;
  }
`;

const StyledSearchInput = styled(Input)`
  ${appStyles.searchInput}
`;
